import { Stack } from '@mantine/core';
import type { ESQueryModel } from '@repo/api-codegen';
import { SelectableProperty } from '../../../components/EntityPageLayout/EntityPropertySidebar';
import {
	AverageRunTimeRender,
	LastExecutionRender,
	ReadOnlyQueryFrequentUsersRender,
	TotalRunTimeRender,
	TotalRunsRender,
} from '../../../components/TableV2/render';
import { QueryResources } from './QueryResources';

export function QueryProperties({ query }: { query: ESQueryModel }) {
	return (
		<Stack spacing="xs">
			<SelectableProperty label="Last run">
				<LastExecutionRender last_execution_at={query.last_execution_at} />
			</SelectableProperty>

			<SelectableProperty label="Run by">
				<ReadOnlyQueryFrequentUsersRender
					frequent_users={query.frequent_users}
					showTooltip
				/>
			</SelectableProperty>

			<SelectableProperty label="Total runs">
				<TotalRunsRender total_runs={query.total_runs} />
			</SelectableProperty>

			<SelectableProperty label="Total runtime">
				<TotalRunTimeRender total_runtime={query.total_runtime} />
			</SelectableProperty>

			<SelectableProperty label="Average runtime">
				<AverageRunTimeRender average_runtime={query.average_runtime} />
			</SelectableProperty>

			<SelectableProperty label="Resources">
				<QueryResources query={query} />
			</SelectableProperty>
		</Stack>
	);
}
